import React, { useState, useEffect } from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";
import { HandPlatter, Building, CalendarClock, Eye, Timer } from "lucide-react";

import { useRecoilState } from 'recoil';
import { paramsAtom, subAtom, outletAtom } from 'core/config/atoms';

import Moment from 'moment';
import { toast } from 'react-toastify';

import ServiceFloor from 'services/serviceFloor';
import ServiceOrder from 'services/serviceOrder';

import ComponentTimer from 'core/widgets/util/ComponentTimer';

import DigShift from 'core/widgets/ui/dailogs/DigShift';

export default function SubPanelA(props) {

    const [, setParam] = useRecoilState(paramsAtom);
    const [sub] = useRecoilState(subAtom);
    const [outlet] = useRecoilState(outletAtom);

    const [floors, setFloors] = useState([]);
    const [filterFloor, setFilterFloor] = useState([]);
    const [orders, setOrders] = useState([]);
    const [filterOrders, setFilterOrders] = useState([]);

    const [record, setRecord] = useState({});

    const [selFloor, setSelFloor] = useState('all');
    const [tab, setTab] = useState('all');

    const [tempURef, setTempURef] = useState('');
    const [tempURT, setTempURT] = useState(-1);

    const [selectionA, setSelectionA] = useState(false);
    const [selectionB, setSelectionB] = useState(false);
    const [selectionC, setSelectionC] = useState(false);

    const floorService = new ServiceFloor();
    const orderService = new ServiceOrder();

    const changeTab = (val) => {
        setTab(val);
        let tempList = [];
        switch (val) {
            case 'takeaway':
                filterOrders.forEach((ord) => {
                    if (ord.type === 'takeaway') {
                        tempList.push(ord);
                    }
                });
                setOrders(tempList);
                break;
            case 'dinein':
                filterOrders.forEach((ord) => {
                    if (ord.type === 'dinein') {
                        tempList.push(ord);
                    }
                });
                setOrders(tempList);
                break;
            case 'roomservice':
                filterOrders.forEach((ord) => {
                    if (ord.type === 'roomservice') {
                        tempList.push(ord);
                    }
                });
                setOrders(tempList);
                break;
            case 'all':
            default:
                setOrders(filterOrders);
        }
    }

    const gotoOrder = (tableId, tableIndex, type, ordID) => {
        setParam({ 'id': tableId, 'index': tableIndex, 'type': type, 'ordID': ordID });
        props.changePanel('B');
    }

    const selectOrder = (ord) => {
        setRecord(ord);
        setSelectionA(true);
    }

    const viewOrder = (tableId, tableIndex) => {
        (async function () {
            var body = {
                'unit': tableId,
                'subunit': tableIndex,
            }
            var res = await orderService.getAllOrdersWithUnit(body, '');
            if (res.data.unit.status !== "none") {
                setRecord(res.data);
                setSelectionB(true);
            }
        })();
    }

    const getColor = (sts) => {
        switch (sts) {
            case 'active':
                return 'bg-green-200';
            case 'inprog':
                return 'bg-red-200';
            case 'checkin':
                return 'bg-blue-200';
            case 'none':
            default:
                return 'bg-white';
        }
    }

    const getChipColorA = (status) => {
        switch (status) {
            case 'open':
                return " bg-blue-100 text-blue-800";
            case 'running':
                return " bg-yellow-100 text-yellow-800";
            default:
                return " bg-gray-100 text-gray-800";
        }
    }

    const getChipColorB = (status) => {
        switch (status) {
            case 'active':
                return 'bg-green-100 text-green-700 ';
            case 'overdeu':
                return 'bg-red-100 text-red-700';
            case 'inprog':
                return 'bg-yellow-100 text-yellow-700';
            case 'none':
            default:
                return 'bg-gray-100 text-gray-700';
        }
    }

    const getOrderType = (ord) => {
        switch (ord.type) {
            case "takeaway":
                return "Take-Away";
            case "dinein":
                if (outlet.outletid.terminaltype === 'qsr') {
                    return "QSR ORDER";
                } else {
                    return "Table Service";
                }
            case "roomservice":
                return "Room Service";
            default:
                return "NA"
        }
    }

    const sortTable = (filter) => {
        setSelFloor(filter);
        if (filter === 'all') {
            setFilterFloor(floors);
        } else {
            let tempList = floors.filter((item) => item.title === filter);
            setFilterFloor(tempList);
        }
    }

    const siftUnit = (tableId, tableIndex) => {
        setTempURef(tableId);
        setTempURT(tableIndex);
        setSelectionC(true);
    }

    const onClose = () => {
        setTempURef('');
        setTempURT(-1);
        setSelectionB(false);
        setSelectionC(false);
        loadData();
    }

    const getTotal = (ordItems) => {
        let total = 0;
        ordItems.forEach((a) => {
            total = total + (a.price * a.qty);
        });
        return total;
    }

    const cancelOrder = (id) => {
        let body = {
            'oid': id,
            "type": "cancel",
            'data': {
                'status': 'cancel'
            }
        };
        orderService.updateOrder(body, '').then((res) => {
            toast.success("Order has been updated!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            loadData();
        });
    }

    const loadOrder = () => {
        (async function () {
            let ordBody = {
                'filter': {
                    'status': { "$in": ['open', 'running'] }
                }
            };
            var ordRes = await orderService.getAllOrders(ordBody, '');
            setOrders(ordRes.data);
            setFilterOrders(ordRes.data);
        })();
    }

    const loadData = () => {
        (async function () {
            var doc = await floorService.getAllFloor({}, '');
            setFloors(doc.data);
            setFilterFloor(doc.data);
            setSelFloor('all');
            loadOrder();
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <>
            {selectionC && <DigShift onClose={onClose} status={selectionC} ordRef={tempURef} ordRT={tempURT} />}
            {
                selectionA && <div className='overflow-y-auto overflow-x-hidden z-50 w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[600px] min-h-screen absolute right-0 p-[20px]'>
                        <ScrollArea>
                            <div className='px-4'>
                                <div className='flex items-center justify-between text-2xl'>
                                    <h1 className='font-sans font-medium text-gray-900 uppercase'>KOT #{record.ordid}</h1>
                                    <span onClick={() => {
                                        setSelectionA(false);
                                        setRecord({});
                                        loadOrder();
                                    }}><i className="las la-times text-xl text-gray-700 cursor-pointer"></i></span>
                                </div>
                                <div className='flex mt-4'>
                                    <p className='font-sans font-medium'>Order Type:
                                        <span className={`ml-4 px-3 inline-flex text-xs leading-5 font-semibold rounded-full uppercase bg-blue-100 text-blue-800`}>
                                            {getOrderType(record)}
                                        </span>
                                    </p>
                                    <p className='ml-8 font-sans font-medium'>Status:
                                        <span className={`ml-4 px-4 inline-flex text-xs leading-5 font-semibold rounded-full uppercase ${getChipColorA(record.status)}`}>
                                            {record.status}
                                        </span>
                                    </p>
                                </div>
                                <hr className='my-2' />
                                <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-4 flex justify-between items-center'>
                                    <span className='flex items-center'>
                                        <i className="las la-file-invoice mr-2 text-xl"></i>Items Summery
                                    </span>
                                </div>
                                <div className='mt-4 flex items-center'>
                                    <p className='text-sm font-bold text-gray-950'>Item Name</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-bold text-gray-950'>Item Unit</p>
                                </div>
                                <hr className='my-2' />
                                {
                                    record.items.map((item) => {
                                        return <div className='flex items-center'>
                                            <p className='text-sm  font-medium text-gray-950'>{item.name}</p>
                                            <div className='flex-grow'></div>
                                            <p className='text-sm font-medium'>{item.qty} x ₹ {item.price} </p>
                                        </div>
                                    })
                                }
                                <div className="w-full mt-2 space-y-1">
                                    <div className="border-t-2 mt-2 py-2 flex items-center justify-between">
                                        <span className="font-medium text-lg">Total</span>
                                        <span className="font-medium text-lg">₹ {Math.round(getTotal(record.items)).toFixed(2)}</span>
                                    </div>
                                </div>
                                <div className='flex mt-2'>
                                    <div className="py-2 mr-2 rounded-md shadow-lg text-center bg-prime text-white font-semibold cursor-pointer flex-grow" onClick={() => {
                                        setSelectionA(false);
                                        gotoOrder(record.unit, record.subunit, record.type, record.ordid);
                                    }}>
                                        Bill Order
                                    </div>
                                    <div className="py-2 ml-2 rounded-md shadow-lg text-center bg-ascent text-white font-semibold cursor-pointer flex-grow" onClick={() => {
                                        setSelectionA(false);
                                        cancelOrder(record._id);
                                    }}>
                                        CANCEL ORDER
                                    </div>
                                </div>
                            </div>
                        </ScrollArea >
                    </div >
                </div >
            }
            {
                selectionB && <div className='overflow-y-auto overflow-x-hidden z-50 w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[600px] min-h-screen absolute right-0 p-[20px]'>
                        <ScrollArea>
                            <div className='px-4'>
                                <div className='flex items-center justify-between text-2xl'>
                                    <h1 className='font-sans font-medium text-gray-900 uppercase'>UNIT : {record.unit.title}</h1>
                                    <span onClick={() => {
                                        setSelectionB(false);
                                        loadData();
                                    }}><i className="las la-times text-xl text-gray-700 cursor-pointer"></i></span>
                                </div>
                                <div className='flex mt-4'>
                                    <p className='font-sans font-medium'>Status:
                                        <span className={`ml-4 px-4 inline-flex text-xs leading-5 font-semibold rounded-full uppercase ${getChipColorB(record.unit.status)}`}>
                                            {record.unit.status}
                                        </span>
                                    </p>
                                </div>
                                <hr className='my-2' />
                                {
                                    record.orders.map((order) => {
                                        return <><div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-4 flex justify-between items-center'>
                                            <span className='flex items-center'>
                                                <i className="las la-file-invoice mr-2 text-xl"></i>KOT #{order.ordid}
                                            </span>
                                        </div>
                                            <div className='mt-4 flex items-center'>
                                                <p className='text-sm font-bold text-gray-950'>Item Name</p>
                                                <div className='flex-grow'></div>
                                                <p className='text-sm font-bold text-gray-950'>Item Unit</p>
                                            </div>
                                            <hr className='my-2' />
                                            {
                                                order.items.map((item) => {
                                                    return <div className='flex items-center'>
                                                        <p className='text-sm  font-medium text-gray-950'>{item.name}</p>
                                                        <div className='flex-grow'></div>
                                                        <p className='text-sm font-medium'>{item.qty} x ₹ {item.price} </p>
                                                    </div>
                                                })
                                            }
                                        </>
                                    })
                                }
                                <hr className='my-2' />
                                <div className='flex mt-4'>
                                    <div className="py-2 mr-2 rounded-md shadow-lg text-center bg-prime text-white font-semibold cursor-pointer flex-grow" onClick={() => {
                                        siftUnit(record.orders[0].unit, record.orders[0].subunit);
                                    }}>
                                        Shift Unit
                                    </div>
                                </div>
                            </div>
                        </ScrollArea >
                    </div >
                </div >
            }
            <div className='w-full min-h-[100vh] bg-gray-100 rounded-md grid grid-cols-12 gap-2'>
                <div className='col-span-2 h-full border-r p-1'>
                    <button className="w-full h-10 py-1 px-3 rounded-md bg-prime hover:bg-primeLight text-white text-sm" onClick={() => { gotoOrder('', 0, 'takeaway', '') }}><i className="las la-plus mr-1"></i> ADD TAKE AWAY</button>
                    <ul>
                        <li className={`py-2 uppercase text-sm font-medium my-2 cursor-pointer rounded-md px-2 border border-dashed ${selFloor === 'all' ? 'text-prime border-prime bg-red-100' : 'hover:bg-gray-200'}`} onClick={() => {
                            sortTable('all');
                        }}>
                            All Floors
                        </li>
                        {
                            floors.length !== 0 && floors.map((cunit) => {
                                return <li className={`py-2 uppercase text-sm font-medium my-2 cursor-pointer rounded-md px-2 border border-dashed ${selFloor === cunit.title ? 'text-prime border-prime bg-red-100' : 'hover:bg-gray-200'}`} key={cunit._id}>
                                    <div className='flex items-center justify-between'>
                                        <span className='flex-grow' onClick={() => { sortTable(cunit.title); }}>{cunit.title}</span>
                                    </div>
                                </li>
                            })
                        }
                    </ul>
                </div>
                <div className='col-span-7'>
                    {
                        filterFloor.length !== 0 && filterFloor.map((cuint) => {
                            return <div className='w-full my-3 border border-gray-200 border-dashed p-1 rounded'>
                                <div className='w-full'>
                                    <div className='flex items-center justify-between'>
                                        <div className='flex items-center'>
                                            <Building size={22} />
                                            <h1 className='text-xl font-medium uppercase ml-1'>{cuint.title}</h1>
                                        </div>
                                    </div>
                                    <div className='my-2 h-[1px] bg-gray-300'></div>
                                </div>
                                <div className='w-full grid grid-cols-4 gap-2'>
                                    {
                                        cuint.units.length === 0 && < div className='h-[114px] p-2 rounded shadow col-span-6 border border-dashed border-prime cursor-pointer hover:shadow-md flex items-center justify-center'>
                                            <h1 className='text-sm font-medium text-prime'>No data found.</h1>
                                        </div>
                                    }
                                    {
                                        cuint.units.length !== 0 && cuint.units.map((unit, index) => {
                                            if (unit.type === 'Room') {
                                                return < div className={`h-[114px] p-2 rounded shadow col-span-1 border border-dashed border-gray-400 cursor-pointer hover:shadow-md ${getColor(unit.status)}`} key={index} onClick={() => {
                                                    if (unit.status !== 'none') {
                                                        gotoOrder(cuint._id, index, 'roomservice', '');
                                                    }
                                                }}>
                                                    <div className='flex justify-between items-center px-1'>
                                                        <div>
                                                            <p className='text-xl font-medium font-serif'>{unit.title}</p>
                                                            <div className='flex items-center'>
                                                                <CalendarClock size={18} />
                                                                <ComponentTimer startTime={Moment(unit.endTime).add(12, 'hours').toISOString()} isOn={unit.status !== 'none'} isElapsed={true} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='bg-gray-200 h-[1px] my-2'></div>
                                                    <div className='flex items-center justify-between'>
                                                        <div className='text-gray-600 flex items-center'>
                                                            <HandPlatter size={20} />
                                                            <p className='text-base font-medium font-serif ml-1'>₹ {unit.pending.toFixed(2)}</p>
                                                        </div>
                                                        <Eye size={18} className='cursor-pointer border border-red-700 p-1 rounded' onClick={() => {
                                                            if (unit.pending > 0) {
                                                                viewOrder(cuint._id, index);
                                                            }
                                                        }} />
                                                    </div>
                                                </div>
                                            } else {
                                                return < div className={`h-[114px] p-2 rounded shadow col-span-1 border border-dashed border-gray-400 cursor-pointer hover:shadow-md ${getColor(unit.status)}`} key={index}>
                                                    <div className='flex justify-between items-center px-1' onClick={() => { gotoOrder(cuint._id, index, 'dinein', ''); }}>
                                                        <div>
                                                            <p className='text-xl font-medium font-serif'>{unit.title}</p>
                                                            <p className='text-base font-medium font-serif'>₹ {unit.pending.toFixed(2)}</p>
                                                        </div>
                                                    </div>
                                                    <div className='bg-gray-200 h-[1px] my-2'></div>
                                                    <div className='flex items-center justify-between'>
                                                        <div className='text-gray-600 flex items-center'>
                                                            <Timer size={20} />
                                                            <ComponentTimer startTime={unit.startTime} isOn={unit.status !== 'none'} isElapsed={false} />
                                                        </div>
                                                        <Eye size={18} className='cursor-pointer border border-red-700 p-1 rounded' onClick={() => { viewOrder(cuint._id, index); }} />
                                                    </div>
                                                </div>
                                            }
                                        })
                                    }
                                </div>
                            </div>
                        })
                    }
                </div>
                <div className='col-span-3'>
                    <div className='flex items-center justify-between mt-2'>
                        <h2 className="text-xl font-medium font-serif truncate text-ascent">
                            Running Orders
                        </h2>
                    </div>
                    <div className="w-full flex justify-between items-center">
                        <div className='h-12 bg-gray-100 rounded'>
                            <ul className="intro-y flex text-sm font-sans space-x-2 my-2">
                                <li className={`px-3 h-8 rounded flex items-center justify-center ${tab === 'all' ? 'text-red-600 font-medium bg-white shadow' : 'text-asent font-medium'}`}><button className='' onClick={() => { changeTab('all') }}>All</button></li>
                                <li className={`px-3 h-8 rounded flex items-center justify-center ${tab === 'takeaway' ? 'text-red-600 font-medium bg-white shadow' : 'text-asent font-medium'}`}><button className='' onClick={() => { changeTab('takeaway') }}>Take-Away</button></li>
                                <li className={`px-3 h-8 rounded flex items-center justify-center ${tab === 'dinein' ? 'text-red-600 font-medium bg-white shadow' : 'text-asent font-medium'}`}><button className='' onClick={() => { changeTab('dinein') }}>Dine-In</button></li>
                                {sub.features.isRoom && <li className={`px-3 h-8 rounded flex items-center justify-center ${tab === 'roomservice' ? 'text-red-600 font-medium bg-white shadow' : 'text-asent font-medium'}`}><button className='' onClick={() => { changeTab('roomservice') }}>Room Service</button></li>}
                            </ul>
                        </div>
                    </div>
                    <hr />
                    <ScrollArea className="w-full h-[90vh] flex flex-col">
                        {
                            orders.length === 0 && <div className='w-full text-prime items-center justify-center mt-8'>
                                <p className='text-sm font-medium text-center'>No orders found.</p>
                            </div>
                        }
                        {
                            orders.map((ord) => {
                                return <div className={`w-full h-[120px] bg-white my-2 px-2 py-2 border rounded-md justify-between cursor-pointer hover:shadow-md border-gray-200`} key={ord._id} onClick={() => {
                                    selectOrder(ord);
                                }}>
                                    <div className="font-medium text-gray-900 text-xl"><b>#{ord.ordid}</b></div>
                                    <div className="font-medium text-sm text-gray-600">{ord.items.length} x Items</div>
                                    <div className="font-medium mt-2">Order Total : ₹ <span className='font-bold'>{ord.total.toFixed(2)}</span></div>
                                    <hr />
                                    <div className="font-medium text-red-600 text-xs my-1">{getOrderType(ord)}</div>
                                </div>
                            })
                        }
                    </ScrollArea>
                </div>
            </div>
            <div className='h-10 w-full'></div>
        </>
    )
}
